import React from 'react'

import { Download } from '../../Downloads'

const DownloadsTab: React.FC = () => {
  return <Download />
}

export default DownloadsTab
